import { render } from "./NotificationCenter.vue?vue&type=template&id=5c8ea3d2&ts=true"
import script from "./NotificationCenter.vue?vue&type=script&lang=ts"
export * from "./NotificationCenter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__